module.exports = __webpack_public_path__ + "static/media/legal-review-builder-help-1.c292f97d.svg";